import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class OnRoute extends Component{
  /**
   * Using componentWillMount instead of didMount so that on initial load this fires in the correct order and not
   * opposite of what componentWillReceiveProps does. i.e. ROUTE should fire before ROUTE_MATCH
   */
  componentWillMount() {
    this.callOnRoute(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.callOnRoute(nextProps, this.props);
    }
  }

  callOnRoute(props, previousProps = {}){
    const { onRoute } = props;
    const payload = {
      prevMatch: previousProps.match,
      prevLocation: previousProps.location,
      match: props.match,
      location: props.location
    };

    onRoute && onRoute(payload);
  }

  render(){
    return React.Children.only(this.props.children);
  }
}

export default withRouter(OnRoute);



// WEBPACK FOOTER //
// ./src/app/components/OnRoute.js